import { HorseType } from '@/utils/horseType'
import { DocumentType } from '@/utils/documentTypes'

export type DocumentRuleType = 'COMPULSORY' | 'COMPULSORY_IF_FG_CONTRACT' | 'COMPULSORY_IF_TROT_AND_CONTRACT' | 'COMPULSORY_IF_COVERED' | 'OPTIONAL_IF_FEMALE' | 'OPTIONAL_IF_MALE' | 'OPTIONAL'

export const documentsRuleTrot: Partial<Record<HorseType, Partial<Record<DocumentType, DocumentRuleType>>>> = {
  'YEARLING': {
    'COPIE_DOCUMENT_ACCOMPAGNEMENT': 'OPTIONAL',
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'CHEVAL_ETRANGER': 'OPTIONAL',
    'COGGINS': 'COMPULSORY',
    'ARTERITE': 'OPTIONAL',
    'PIROPLASMOSE_SELLER': 'OPTIONAL',
    'CERTIFICAT_SANITAIRE_ARQANA': 'COMPULSORY',
    'TESTICLES_CERTIFICATE': 'OPTIONAL_IF_MALE',
  },
  'CAE': {
    'COPIE_DOCUMENT_ACCOMPAGNEMENT': 'OPTIONAL',
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'CHEVAL_ETRANGER': 'OPTIONAL',
    'COGGINS': 'COMPULSORY',
    'ARTERITE': 'OPTIONAL',
    'PIROPLASMOSE_SELLER': 'OPTIONAL',
    'METRITE': 'OPTIONAL_IF_FEMALE',
    'CERTIFICAT_SANITAIRE_ARQANA': 'COMPULSORY',
    'DOSSIER_VETERINAIRE': 'OPTIONAL',
    'TESTICLES_CERTIFICATE': 'OPTIONAL_IF_MALE',
  },
  'MARE': {
    'COPIE_DOCUMENT_ACCOMPAGNEMENT': 'OPTIONAL',
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'CHEVAL_ETRANGER': 'OPTIONAL',
    'COGGINS': 'COMPULSORY',
    'ARTERITE': 'OPTIONAL',
    'PIROPLASMOSE_SELLER': 'OPTIONAL',
    'METRITE': 'OPTIONAL',
    'CERTIFICAT_SANITAIRE_ARQANA': 'COMPULSORY',
    'REPRODUCTION': 'OPTIONAL',
    'CERTIFICAT_SAILLIE_SELLER': 'COMPULSORY_IF_COVERED',
  },
  'STALLION': {
    'COPIE_DOCUMENT_ACCOMPAGNEMENT': 'OPTIONAL',
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'CHEVAL_ETRANGER': 'OPTIONAL',
    'COGGINS': 'COMPULSORY',
    'ARTERITE': 'COMPULSORY',
    'PIROPLASMOSE_SELLER': 'OPTIONAL',
    'METRITE': 'OPTIONAL',
    'CERTIFICAT_SANITAIRE_ARQANA': 'COMPULSORY',
  },
  'STALLION_PROSPECT': {
    'COPIE_DOCUMENT_ACCOMPAGNEMENT': 'OPTIONAL',
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'CHEVAL_ETRANGER': 'OPTIONAL',
    'COGGINS': 'COMPULSORY',
    'ARTERITE': 'COMPULSORY',
    'PIROPLASMOSE_SELLER': 'OPTIONAL',
    'METRITE': 'OPTIONAL',
    'CERTIFICAT_SANITAIRE_ARQANA': 'COMPULSORY',
  },
  'STALLION_PART': {
    'TITRE_PROPRIETE_SELLER': 'OPTIONAL',
  },
  'BREEDING_RIGHT': {
    'TITRE_PROPRIETE_SELLER': 'OPTIONAL',
  },
  'PROTRUSION': {
    'TITRE_PROPRIETE_SELLER': 'OPTIONAL',
  },
  'MAIDEN': {
    'COPIE_DOCUMENT_ACCOMPAGNEMENT': 'OPTIONAL',
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'CHEVAL_ETRANGER': 'OPTIONAL',
    'COGGINS': 'COMPULSORY',
    'ARTERITE': 'OPTIONAL',
    'PIROPLASMOSE_SELLER': 'OPTIONAL',
    'METRITE': 'OPTIONAL',
    'CERTIFICAT_SANITAIRE_ARQANA': 'COMPULSORY',
    'REPRODUCTION': 'OPTIONAL',
  },
  'FOAL': {
    'COPIE_DOCUMENT_ACCOMPAGNEMENT': 'OPTIONAL',
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'CHEVAL_ETRANGER': 'OPTIONAL',
    'COGGINS': 'COMPULSORY',
    'ARTERITE': 'OPTIONAL',
    'PIROPLASMOSE_SELLER': 'OPTIONAL',
    'CERTIFICAT_SANITAIRE_ARQANA': 'COMPULSORY',
    'TESTICLES_CERTIFICATE': 'OPTIONAL_IF_MALE',
  },
}
